import * as React from "react";
import { Field, QueryProvider } from "../../../components/context/query";
import { AddToCrateChart } from "./charts/AddToCrateChart";
import { CategoryChart } from "./charts/CategoryChart";
import { CuratorChart } from "./charts/CuratorChart";
import { PlaylistChart } from "./charts/PlaylistChart";
import { ViewsChart } from "./charts/ViewsChart";
import { generateDS } from "utils/datasource";
import { Environment } from "env";

const allowedFields: Field[] = [{
    dataField: 'curator',
    dataType: 'string'
},
{
    dataField: 'category_name',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: generateDS(Environment.DOWNLOAD_API_URL, '/playlist-categories', 'id', true), valueExpr: 'name', displayExpr: 'name' }
},
{
    dataField: 'country',
    caption: 'Country',
    dataType: 'string'
},
{
    dataField: 'city',
    caption: 'City',
    dataType: 'string'
},
{
    dataField: 'membership',
    name: 'has_membership',
    editorOptions: { opened: true },
    caption: 'Has Membership',
    dataType: 'boolean',
    filterOperations: ["="]
},
{
    dataField: 'membership',
    caption: 'Subscription Plan',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: ['standard', 'premium'] }
},
{
    dataField: 'membership_library',
    caption: 'Subscription Library',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: [{ val: 'all', label: 'All' }, { val: 'music', label: 'Open Format' }, { val: 'latin', label: 'Latino' }], displayExpr: 'label', valueExpr: 'val' }
},
{
    dataField: 'dj_type',
    caption: 'DJ Type',
    dataType: 'string'
}]
export class Playlist extends React.Component {
    render() {
        return <div className="dashboard">
            <div className='charts'>
                <QueryProvider fields={allowedFields}>{({ filter }) => {
                    return <div className='bpm-container'>
                        <div className='row'>
                            <div className='col'>
                                {filter}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <PlaylistChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <CategoryChart />
                            </div>
                            <div className='col'>
                                <CuratorChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <ViewsChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <AddToCrateChart />
                            </div>
                        </div>
                    </div>
                }}</QueryProvider>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Playlist/Playlist.tsx